import {memo} from 'react';

import type {SVGProps} from 'react';

export const NotebookIcon = memo(function NotebookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M5.83301 7.62492V6.20825C5.83301 5.33325 6.54134 4.58325 7.45801 4.58325H16.333C17.208 4.58325 17.958 5.29159 17.958 6.20825V17.0833C17.958 17.9583 17.2497 18.7083 16.333 18.7083H7.45801C6.58301 18.7083 5.83301 17.9999 5.83301 17.0833V14.4583V7.62492Z"
          fill="var(--icon-fill-green)"
        />
        <path
          d="M3.95801 8.33325V7.08325"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinejoin="round"
        />
        <path
          d="M3.95801 11.6667V10"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinejoin="round"
        />
        <path
          d="M11.0413 17.2917H5.62467C4.70801 17.2917 3.95801 16.5417 3.95801 15.625V14.375"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.41699 2.70825H14.792C15.7087 2.70825 16.4587 3.45825 16.4587 4.37492V15.6249C16.4587 16.5416 15.7087 17.2916 14.792 17.2916H13.8337"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.95801 5.45825V4.37492C3.95801 3.45825 4.70801 2.70825 5.62467 2.70825H7.33301"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.70801 5.625H5.20801"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.70801 8.54175H5.20801"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.70801 11.4583H5.20801"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.70801 14.375H5.20801"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.12467 5.625H12.708C12.958 5.625 13.1247 5.79167 13.1247 6.04167V8.125C13.1247 8.375 12.958 8.54167 12.708 8.54167H8.12467C7.87467 8.54167 7.70801 8.375 7.70801 8.125V6.04167C7.70801 5.79167 7.87467 5.625 8.12467 5.625Z"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.458 4.79175H16.8747C17.1247 4.79175 17.2913 4.95841 17.2913 5.20841V6.87508C17.2913 7.12508 17.1247 7.29175 16.8747 7.29175H16.458"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.458 8.95825H16.8747C17.1247 8.95825 17.2913 9.12492 17.2913 9.37492V11.0416C17.2913 11.2916 17.1247 11.4583 16.8747 11.4583H16.458"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.458 13.125H16.8747C17.1247 13.125 17.2913 13.2917 17.2913 13.5417V15.2083C17.2913 15.4583 17.1247 15.625 16.8747 15.625H16.458"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
